import { Column } from '@tempmee/react';
import { RichTextViewer } from '~/commonComponents';
import { Colors } from '~/themes/colors';
import { InfoSection } from './InfoSection';

interface IJobDescriptionReviewProps {
  description: string;
  onEditClick: () => void;
}

export const JobDescriptionReview = ({ description, onEditClick }: IJobDescriptionReviewProps) => {
  return (
    <InfoSection
      title="Job Description"
      titleColor="neutral_600"
      titleFontSize={24}
      rightActionIcon="edit-pencil"
      onRightActionPress={onEditClick}
      containerStyle={{ backgroundColor: Colors.white, paddingInline: 40 }}
    >
      <Column gap={4}>
        <RichTextViewer content={description} />
      </Column>
    </InfoSection>
  );
};
